import { ID_CHOOSING_SURNAME } from 'civil-status/components/step/form/last-step/accordions/subject/form/list/list-reason-choosing-surname';
import { ParentVM, RecapVM, DatiNascita } from 'civil-status/view-models/step-form';

export const transformerDatiNascita = (
  data: Array<RecapVM>,
  idEvento?: number,
  subject?: ParentVM
): DatiNascita | undefined => {
  // se è l'ultimo step di domande singole salvare dati aggiuntivi
  const isNatoMorto = Boolean(
    data?.find(
      (itemStep) =>
        itemStep.codResponse === 60010030 || itemStep?.responseData?.key?.idRisposta === 60010030
    )
  );

  const isNatoVivoMaDeceduto = Boolean(
    data?.find(
      (itemStep) =>
        itemStep.codResponse === 60010031 || itemStep?.responseData?.key?.idRisposta === 60010031
    )
  );

  if (!subject && !(isNatoMorto || isNatoVivoMaDeceduto)) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    oraNascita: subject?.generality?.birthTime
      ? subject.generality?.birthTime?.toFormat('HH')
      : undefined,
    minutoNascita: subject?.generality?.birthTime
      ? subject.generality?.birthTime?.toFormat('mm')
      : undefined,
    sceltaCognome: subject?.generality?.surnameItem?.id?.toString() || undefined,
    precisazioneCognome:
      subject?.generality?.reasonChoosingSurname &&
      subject?.generality?.reasonChoosingSurname.id?.toString() !== ID_CHOOSING_SURNAME.Nessuno
        ? subject?.generality?.reasonChoosingSurname.id?.toString() === ID_CHOOSING_SURNAME.Altro
          ? subject?.generality?.clarificationSurname
          : subject?.generality?.reasonChoosingSurname.value.charAt(0).toLowerCase() +
            subject?.generality?.reasonChoosingSurname.value.slice(1)
        : undefined,
    luogoFiliazione: subject?.generality?.descriptionBirthPlace || undefined,
    accertamento: subject?.generality?.verificationTypeItem?.id?.toString() || undefined,
    nascitaSoggetto: subject?.generality?.bornTypology || undefined,
    flagNatoMorto: isNatoMorto ? '1' : '0',
    flagNatoVivoMaDeceduto: isNatoVivoMaDeceduto ? '1' : '0',
    flagPartoGemellare: subject?.generality
      ? subject?.generality?.isWithTwins
        ? '1'
        : '0'
      : undefined,
    numeroGemelli: subject?.generality?.allTwins || undefined,
    progressivoGemello: subject?.generality?.currentTwin || undefined,
    dataAccertamentoNecroscopo: subject?.generality?.necropsyDate
      ? subject?.generality?.necropsyDate.toFormat('yyyy-MM-dd')
      : undefined,
  };
};
